module.exports = "//static.hsappstatic.net/salesImages/static-1.403/sales-content/sequences-zero-state@3x.png"